'use client'

import StepperControl from '~/components/ui/stepper-control'

interface GuestSelectorProps {
  label: string
  description?: string
  value: number
  min: number
  max: number
  onChange: (value: number) => void
}

export default function GuestSelector({
  label,
  description,
  value,
  min,
  max,
  onChange,
}: GuestSelectorProps) {
  const handleDecrement = () => {
    if (value > min) onChange(value - 1)
  }

  const handleIncrement = () => {
    if (value < max) onChange(value + 1)
  }

  return (
    <div className="flex items-center justify-between">
      <div>
        <div className="whitespace-nowrap font-lexend text-[10px] font-[400] text-secondary-950">
          {label}
        </div>
        {description && (
          <div className="whitespace-nowrap font-lexend text-[10px] font-light text-[#666B74]">
            {description}
          </div>
        )}
      </div>
      <StepperControl
        value={value}
        min={min}
        max={max}
        onDecrement={handleDecrement}
        onIncrement={handleIncrement}
        onChange={onChange}
      />
    </div>
  )
}
